import React, { useState } from "react";
import Modal from "../../Modals/Modal";
import { useAuth } from "../../../../contexts/AuthContext";
import { db } from "../../../../firebase";
import Alert from "../../../Alert";
import { svg } from "../../../../resources/Svg";
import { useHistory } from "react-router-dom";

const EditNameModal = ({ open, setOpen, _fname, _lname }) => {
  const { currentUser } = useAuth();
  const [errorMsg, setErrorMsg] = useState("");
  const [notificationMsg, setNotificationMsg] = useState("");
  const [fname, setFname] = useState(_fname);
  const [lname, setLname] = useState(_lname);
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!lname || !lname) return setErrorMsg("All fields are required");
    db.users
      .doc(currentUser.uid)
      .update({
        fname: fname,
        lname: lname,
      })
      .then(() => {
        setErrorMsg("");
        setFname(fname);
        setLname(lname);
        setNotificationMsg("The Name has been changed successfully");
        history.push("/settings/general");
      })
      .catch((error) => {
        setNotificationMsg("");
        setErrorMsg(error.message);
      });
  };

  return (
    <>
      <Modal open={open} h="auto">
        <div className="flex flex-col space-y-5">
          <div className="flex items-center justify-between">
            <h1 className="text-gray-800 text-xl font-semibold text-center">
              Update the Name
            </h1>
            <button
              className="focus:outline-none"
              onClick={() => {
                setErrorMsg("");
                setNotificationMsg("");
                setOpen(false);
              }}
            >
              <svg
                className="h-6 w-6 text-red-600 "
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            style={{ height: "1px" }}
            className="w-full bg-gray-700 bg-opacity-30 rounded-sm"
          ></div>
          <form className=" space-y-6" onSubmit={(e) => handleSubmit(e)}>
            <div className="space-y-6">
              <section className="flex flex-col mb-4">
                <label htmlFor="fname" className="mb-2  text-gray-700">
                  First Name
                </label>
                <input
                  spellCheck="false"
                  autoComplete="off"
                  className=" shadow-md py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                  type="text"
                  name="fname"
                  required
                  placeholder="First Name Here"
                  value={fname}
                  onChange={(e) => setFname(e.target.value)}
                />
              </section>

              <section className="flex flex-col mb-4">
                <label htmlFor="lname" className="mb-2  text-gray-700">
                  Last Name
                </label>
                <input
                  spellCheck="false"
                  autoComplete="off"
                  className="shadow-md py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                  type="text"
                  name="lname"
                  required
                  value={lname}
                  placeholder="Last Name Here"
                  onChange={(e) => setLname(e.target.value)}
                />
              </section>
            </div>

            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <svg
                  className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
              Update My Name
            </button>
          </form>
          {errorMsg && (
            <Alert
              svg={svg.danger}
              iconFlag={"red-500"}
              textFlag={"red-600"}
              text={errorMsg}
            />
          )}
          {notificationMsg && (
            <Alert
              svg={svg.success}
              bgColor={"green-100"}
              iconFlag={"green-500"}
              textFlag={"green-600"}
              text={notificationMsg}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default EditNameModal;
